module.exports = __webpack_public_path__ + "static/media/5.d9bc0595.JPG";